import 'gis';
import * as app from 'CMS/core/application';
import RouteCalculatorRequest from './RouteCalculatorDTOs/RouteCalculatorRequest';
import RoutingResult from './RouteCalculatorDTOs/RoutingResult';

export default class RouteCalculatorV2 {
    private baseUrl: string;
    private calculateRouteUrl: string;
    private calculateVoyageUrl: string;

    private constructor(url: string) {
        this.baseUrl = url;
        this.calculateRouteUrl = this.baseUrl + '/CalculateRoute';
        this.calculateVoyageUrl = this.baseUrl + '/Calculate';
    }

    public calculateRoute(request: RouteCalculatorRequest): Promise<RoutingResult> {
        return this.calculate(this.calculateRouteUrl, request);
    }

    public calculateVoyage(request: RouteCalculatorRequest): Promise<RoutingResult> {
        return this.calculate(this.calculateVoyageUrl, request);
    }

    private calculate(url: string, request: RouteCalculatorRequest): Promise<RoutingResult>  {
        return new Promise((resolve, reject) => {
            var $calculateRouteTask = $.ajax(url, {
                type: 'POST',
                data: JSON.stringify(request),
                contentType: 'application/json'
            });

            $calculateRouteTask.done((data, textStatus, jqXHR) => {
                resolve(new RoutingResult(data));
            }).fail((e) => {
                reject(e);
            });
        });
    }

    public static create(url: string): RouteCalculatorV2 {
        if (url == null || url == '') {
            url = "~/visuris/api/RouteCalculatorv2";
        }
        return new RouteCalculatorV2(app.formatLocationUrl(url));
    }
}